import { Subscription } from 'rxjs';
import { EnvironmentHelperService } from '../../../services/environment-helper.service';
import { UiVersion } from '../../../model/ui-version';
import { Component, OnInit, OnDestroy } from '@angular/core';


@Component({
  selector: 'app-changelog',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.scss']
})
export class ChangelogComponent implements OnInit, OnDestroy {

  versions: UiVersion[] = [];

  private versionsSubscription?: Subscription;

  constructor(
    private environmentService: EnvironmentHelperService
  ) { }

  ngOnInit(): void {
    this.versionsSubscription = this.environmentService.getUiVersions().subscribe(versions => {
      this.versions = versions.sort((a, b) => new Date(b.releaseDate).getTime() - new Date(a.releaseDate).getTime());
    });
  }

  onError(event: any) {
    console.log(event);
  }

  getFileName(version: string) {
    const language = localStorage.getItem('language');

    return `assets/changelog/${language}/changelog-${version}.md`;
  }

  ngOnDestroy(): void {
    this.versionsSubscription?.unsubscribe();
  }
}
